/* eslint-disable max-len */
// Node Module Imports
import React from 'react'

// Component Imports
import { footnoteLanguage } from '../../../../utils/static-data/footnoteLanguage'
import Footnote from '../../../elements/Footnote'

// Utility Imports

const WhatToLookFor = () => (
  <div className="py-7">
    <div className="container">
      <div className="h2">
        Earn a degree in an allied healthcare field online in just 18 months.
        <Footnote content={'{{"shortcode": "footnote", "content": "${footnoteLanguage.programLength}"}}'} />
      </div>
      <div className="row mt-8">
        <div className="col-12 col-md-6">
          Earn your degree in an allied healthcare field from the comfort of home. Don't let a busy life get in the way
          of pursuing your dreams of a new career. Take flexible study online courses at Ultimate Medical Academy from
          your personal office, your favorite coffee shop, or almost anywhere! You can earn your degree in an allied
          healthcare field online on a schedule that fits into your life.
          <Footnote content={'{{"shortcode": "footnote", "content": "${footnoteLanguage.flexibleSchedule}"}}'} /> Make
          your education work for you.
        </div>
        <div className="col-12 col-md-6">
          With UMA's quality career training and personalized support, you can feel comfortable knowing there will
          always be someone guiding you along your journey. Take your first step toward earning an online degree in an
          allied healthcare field and enroll today.
        </div>
      </div>
    </div>
  </div>
)

export default WhatToLookFor
